module.exports = function (his_self) {
  var help = "New World Bonus Phase";
  var cb = '';
  if (his_self.game.state.new_world_bonus['ottoman'] > 0) {
    if (cb != '') {
      cb += ', ';
    }
    cb += "Turks (".concat(his_self.game.state.new_world_bonus['ottoman'], ")");
  }
  if (his_self.game.state.new_world_bonus['hapsburg'] > 0) {
    if (cb != '') {
      cb += ', ';
    }
    cb += "Hapburg (".concat(his_self.game.state.new_world_bonus['hapsburg'], ")");
  }
  if (his_self.game.state.new_world_bonus['england'] > 0) {
    if (cb != '') {
      cb += ', ';
    }
    cb += "English (".concat(his_self.game.state.new_world_bonus['england'], ")");
  }
  if (his_self.game.state.new_world_bonus['france'] > 0) {
    if (cb != '') {
      cb += ', ';
    }
    cb += "French (".concat(his_self.game.state.new_world_bonus['france'], ")");
  }
  if (his_self.game.state.new_world_bonus['papacy'] > 0) {
    if (cb != '') {
      cb += ', ';
    }
    cb += "Papacy (".concat(his_self.game.state.new_world_bonus['papacy'], ")");
  }
  if (his_self.game.state.new_world_bonus['protestant'] > 0) {
    if (cb != '') {
      cb += ', ';
    }
    cb += "Prots (".concat(his_self.game.state.new_world_bonus['protestant'], ")");
  }
  if (cb === '') {
    cb = 'no new world card bonuses this turn...';
  } else {
    cb = 'New World Card Bonuses: ' + cb;
  }
  var html = "\n      <div class=\"new-world-overlay\" id=\"new-world-overlay\">\n\t<div class=\"help\">".concat(help, "</div>\n\t<div class=\"content\">\n          <div class=\"conquests\">\n            <div class=\"title\">conquests</div>\n          </div>\n          <div class=\"colonies\">\n            <div class=\"title\">colonies</div>\n          </div>\n          <div class=\"explorations\">\n            <div class=\"title\">explorations</div>\n          </div>\n        </div>\n\t<div class=\"card_bonuses\">").concat(cb, "</div>\n      </div>\n  ");
  return html;
};